export enum VerificationMode {
  Authenticator = 'authenticator',
  Backup = 'backup',
}
